import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { FormControl, InputAdornment, OutlinedInput } from '@mui/material';

import { BLACK, SCOUT_BLUE } from '../../ThemeContext/constants';

import type { ChangeEvent } from 'react';

export interface SearchFieldProps {
  id: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  dataTestId?: string;
}

const searchFieldSx = {
  fontFamily: 'Source Sans Pro, sans-serif',
  fontSize: '20px',
  fontWeight: 'regular',
  borderRadius: '6px',
  minHeight: '54px',
  '& legend': {
    display: 'none'
  },
  '& svg': {
    fontSize: '31px',
    color: SCOUT_BLUE
  },
  '& input': {
    padding: '10.5px 11px 15.5px 11px',
    color: BLACK
  },
  '& fieldset': {
    borderColor: '#EAEEF0'
  },
  '&:hover': {
    '& fieldset': {
      borderColor: '#DADEE0 !important'
    }
  }
};

const SearchField = ({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
  fullWidth = false,
  dataTestId
}: SearchFieldProps): React.ReactElement => (
  <FormControl fullWidth={fullWidth}>
    <OutlinedInput
      data-testid={dataTestId}
      disabled={disabled}
      fullWidth={fullWidth}
      id={id}
      onChange={onChange}
      placeholder={placeholder}
      sx={searchFieldSx}
      value={value}
      startAdornment={
        <InputAdornment position="start" sx={{ padding: '0px 0px 0px 14px' }}>
          <SearchIcon />
        </InputAdornment>
      }
    />
  </FormControl>
);

export default SearchField;
